var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crly-a-common-search-keyword-category-btn"},[_c('button',{class:{ active: _vm.category === _vm.active },on:{"click":_vm.clickBtn}},[_vm._v(" "+_vm._s(_vm.$t(`common.category.cat${_vm.category}`))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }